<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-edit-button/lecture-edit-button.component.ts.LectureEditButtonComponent.html